export const EdgeCreateHeader = () => (
    <div
        className={[
            "py-2 px-0 text-center",
            "bg-[var(--diagram-table-header-bg)] text-[var(--diagram-table-text)]",
        ].join(" ")}
    >
        <span className="font-bold">Create reference</span>
    </div>
);
